import { render, staticRenderFns } from "./ElEmbed.vue?vue&type=template&id=1bf0f6ee"
import script from "./ElEmbed.vue?vue&type=script&lang=js"
export * from "./ElEmbed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports